import { useContext, useEffect, useState } from "react";
import { ActivePassiveItemDto } from "../../../../dtos/catalogs/ActivePassiveItem/ActivePassiveItemDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import ActivePassiveItemDetailSkeleton from "./ActivePassiveItemDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import ActivePassiveItemMainDetail from "./ActivePassiveItemMainDetail";

interface IProps {
  model: ActivePassiveItemDto | null;
  modelUpdatedEvent: (newModel: ActivePassiveItemDto) => void;
}

interface ActivePassiveItemModel {
  id: string;
  name: string;
  uniqueCode?: string;
  description: string;
  createdDate: Date;
  itemTypeActivePassiveItem?: number;
  analyticsTypeOfActivePassiveItemId?: string;
  vendorCustomerId?: string;
}

export const ACtivePassiveItemDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ActivePassiveItemModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("description", model.description);
      setValue("createdDate", model.createdDate);
      setValue("itemTypeActivePassiveItem", model.itemTypeActivePassiveItem);
      setValue("analyticsTypeOfActivePassiveItemId", model.analyticsTypeOfActivePassiveItemId);
      setValue("vendorCustomerId", model.vendorCustomerId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: ActivePassiveItemModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: ActivePassiveItemDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <ActivePassiveItemDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <ActivePassiveItemMainDetail />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
